<div class="mobile-page">
    <section class="app-hero-shell">
        <div class="app-hero-card">
            <div class="app-copy">
                <p class="eyebrow">
                    {{ 'MOBILE.HERO.EYEBROW' | translate }}
                </p>
                <h1 [innerHTML]="'MOBILE.HERO.TITLE' | translate"></h1>
                <p class="subtitle">{{ 'MOBILE.HERO.SUBTITLE' | translate }}</p>
                <p class="description">{{ 'MOBILE.DESCRIPTION_2' | translate }}</p>

                <div class="feature-grid">
                    @for (feature of features; track feature.key) {
                        <article class="feature-card">
                            <img class="feature-icon" alt="" src="assets/images/mobile/{{feature.icon}}">
                            <div>
                                <h2>{{ 'MOBILE.ARGUMENTS.' + feature.key | translate }}</h2>
                                <p>{{ 'MOBILE.ARGUMENTS.' + feature.key + '_TEXT' | translate }}</p>
                            </div>
                        </article>
                    }
                </div>
            </div>

            <div class="app-visual">
                <img class="moon-backdrop" src="assets/images/mobile/background.webp" alt="">
                <img class="phone" [src]="getAboutImage()" alt="">

                <div class="platform-links">
                    <a href="https://play.google.com/store/apps/details?id=com.freckles.of.couple.moony"
                       target="_blank"
                       rel="noopener noreferrer">
                        Android
                    </a>
                    <a href="https://apps.apple.com/us/app/mondkalender-moony/id1441214285"
                       target="_blank"
                       rel="noopener noreferrer">
                        iOS
                    </a>
                </div>

                <article class="floating-card floating-card-top">
                    <p>{{ 'MOBILE.HERO.CALLOUT_1' | translate }}</p>
                    <span class="floating-line"></span>
                </article>

                <article class="floating-card floating-card-bottom">
                    <p>{{ 'MOBILE.HERO.CALLOUT_2' | translate }}</p>
                    <span class="floating-line"></span>
                </article>
            </div>
        </div>
    </section>

    <section class="app-features-shell">
        <div class="app-features-card">
            <div class="features-intro">
                <p class="eyebrow">{{ 'MOBILE.FEATURES.EYEBROW' | translate }}</p>
                <h2 [innerHTML]="'MOBILE.FEATURES.HEADLINE' | translate"></h2>
                <p>{{ 'MOBILE.FEATURES.DESCRIPTION' | translate }}</p>
            </div>

            <img class="features-orbit" src="assets/images/mobile/features.webp" alt="">

            <div class="app-feature-grid">
                @for (feature of appFeatures; track feature.key) {
                    <article class="app-feature-card">
                        <img class="app-feature-icon" alt="" src="assets/images/mobile/{{feature.icon}}">
                        <div>
                            <h3>{{ 'MOBILE.FEATURES.' + feature.key | translate }}</h3>
                            <p>{{ 'MOBILE.FEATURES.' + feature.key + '_DETAILS' | translate }}</p>
                        </div>
                    </article>
                }
            </div>
        </div>
    </section>

    <section class="app-download-shell">
        <div class="app-download-card">
            <h2 [innerHTML]="'MOBILE.DOWNLOAD.TITLE' | translate"></h2>
            <div class="store-links">
                <a href="https://apps.apple.com/us/app/mondkalender-moony/id1441214285"
                   target="_blank"
                   rel="noopener noreferrer">
                    <img alt="" src="assets/images/mobile/apple.webp">
                    <span class="store-copy">
                        <span>{{ 'MOBILE.DOWNLOAD.APP_STORE_PREFIX' | translate }}</span>
                        <strong>{{ 'MOBILE.DOWNLOAD.APP_STORE' | translate }}</strong>
                    </span>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.freckles.of.couple.moony"
                   target="_blank"
                   rel="noopener noreferrer">
                    <img alt="" src="assets/images/mobile/google_play.webp">
                    <span class="store-copy">
                        <span>{{ 'MOBILE.DOWNLOAD.PLAY_STORE_PREFIX' | translate }}</span>
                        <strong>{{ 'MOBILE.DOWNLOAD.PLAY_STORE' | translate }}</strong>
                    </span>
                </a>
            </div>
        </div>
    </section>
</div>
